// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `RankTier`.
const RankTier = __t.enum("RankTier", {Rookie: __t.unit(),
  Scout: __t.unit(),
  Defuser: __t.unit(),
  Technician: __t.unit(),
  Operator: __t.unit(),
  EOD: __t.unit(),
  Master: __t.unit(),
  Grandmaster: __t.unit(),
});

export default RankTier;


